<template>
  <div class="btn-group" :class="{open: isOpen}">
    <button type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            @click="isOpen = !isOpen"
            aria-haspopup="true">
      <slot name="dropdownAction">
      Dropdown
      <span class="caret"></span>
      </slot>
    </button>
    <ul class="dropdown-menu">
      <slot></slot>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'ButtonDropdown',
  data()
  {
    return {isOpen: false}
  },
  methods:
  {
    close: function()
    {
      this.isOpen = false
    }
  }
}
</script>
